<template>
<div class="flex flex-col m-4">
  <div class="flex flex-row bg-white p-1 justify-center">
    <div @click="upload = 'doctorRoster'" :class="upload === 'doctorRoster' ? 'text-blue' : 'hover:text-blue'" class="text-grey text-m mx-6 font-semibold cursor-pointer" >Upload Doctor Roster</div>
    <div @click="upload = 'chatAvailability'" :class="upload === 'chatAvailability' ? 'text-blue' : 'hover:text-blue'" class="text-grey text-m mx-6 font-semibold cursor-pointer" >Upload Chat Availability</div>
  </div>
  <div class="flex flex-row bg-grey-lightest self-center mb-4" style="height: 0.125rem; width: 420px">
    <div class="w-1/2" :class="[upload === 'doctorRoster' ? 'bg-blue' : '']"></div>
    <div class="w-1/2" :class="[upload === 'chatAvailability' ? 'bg-blue' : '']"></div>
  </div>
  <div v-if="upload === 'doctorRoster'" class="m-4">
    <p class="text-sm py-6 text-center"> Please select a file to upload</p>
    <div class="fieldsDiv">
      <div class="message display:flex flex-direction:column"> 
        <div class="border-b border-solid w-64 h-8 text-align">
          <p class="pt-3 text-m truncate">{{rosterFile.name}}</p>
        </div>
        <div class="text-xs py-1 ">
          {{message}}
        </div>
      </div>
      <div class="">
        <div class="px-4 items-center margin-top:-9px">
          <div class="flex flex-column">
            <div class="db-file-upload">
              <div class="file">
                <label class="file-label width:100%">
                  <input class="file-input" style="display:none" accept=".csv, .pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="file" @change="handleFileUpload()">
                  <div class="hover:shadow-md self-center bg-blue p-2 px-3 rounded text-white text-xs font-light cursor-pointer">Select</div>
                </label>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
  <div v-if="upload === 'doctorRoster'" class="buttons">
    <div>
      <button class="hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" v-on:click="cancel()">Cancel</button>
    </div>
    <div>
      <button class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4" :class="!rosterFile || !rosterFile.name ? 'cursor-not-allowed' : 'cursor-pointer'" v-on:click="rosterFile && rosterFile.size && submitRosterFile()">Upload</button>
    </div>
  </div>
  <div v-if="upload === 'chatAvailability'" class="m-4">
    <p class="text-sm py-6 text-center"> Please select a file to upload chat availability</p>
    <div class="fieldsDiv">
      <div class="message display:flex flex-direction:column"> 
      <div class="border-b border-solid w-64 h-8 text-align">
        <p class="pt-3 text-m truncate">{{chatFile.name}}</p>
      </div>
        <div class="text-xs py-1 ">
          {{message}}
        </div>
      </div>
      <div class="">
        <div class="px-4 items-center margin-top:-9px">
          <div class="flex flex-column">
            <div class="db-file-upload">
              <div class="file">
                <label class="file-label width:100%">
                  <input class="file-input" style="display:none" accept=".pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="chatfile" @change="handleChatFileUpload()">
                  <div class="hover:shadow-md self-center bg-blue p-2 px-3 rounded text-white text-xs font-light cursor-pointer">Select</div>
                </label>
              </div>
            </div>
            </div>          
          </div>
        </div>
      </div>
    </div>
    <div v-if="upload === 'chatAvailability'" class="buttons">
      <div>
        <button class="hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" v-on:click="cancel()">Cancel</button>
      </div>
      <div>
        <button class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4" :class="!chatFile || !chatFile.name ? 'cursor-not-allowed' : 'cursor-pointer'" v-on:click="chatFile && chatFile.size && submitChatFile()">Upload</button>
      </div>
    </div>      
  </div>
</template>


<script>
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import DocRosterAPI from './../../api/doctor_roster'
import Vue from 'vue'
Vue.use(VueToast)
export default {
  data () {
    return {
      test: 'File Upload Page',
      rosterFile: {},
      chatFile: {},
      message: 'eg : file.csv',
      upload: 'doctorRoster'
    }
  },
  methods: {
    submitRosterFile () {
      if (this.rosterFile && this.rosterFile.size) {
        let formData = new FormData()
        formData.append('file', this.rosterFile)
        DocRosterAPI.uploadRoster(formData)
          .then(response => {
            if (response.status === 200) {
              this.rosterFile = {}
              this.$toast.open({
                message: 'File Uploaded Successfully',
                type: 'success',
                posision: 'bottom-right'
              })
            }
          }).catch((error) => {
            console.log(error)
            this.$toast.open({
              message: 'Error while uploading the roster',
              type: 'error',
              position: 'bottom-right'
            })
          })
      } else {
        this.$toast.open({
          message: 'Please select a file to upload',
          type: 'error',
          position: 'top-right'
        })
      }
    },
    submitChatFile () {
      if (this.chatFile && this.chatFile.size) {
        let formData = new FormData()
        formData.append('file', this.chatFile)
        DocRosterAPI.uploadChatAvailability(formData)
          .then(response => {
            if (response.status === 200) {
              this.chatFile = {}
              this.$toast.open({
                message: 'Chat Availability File Uploaded Successfully',
                type: 'success',
                posision: 'bottom-right'
              })
            }
          }).catch((error) => {
            console.log(error)
            this.$toast.open({
              message: 'Error while uploading the roster',
              type: 'error',
              position: 'bottom-right'
            })
          })
      }
    },
    cancel () {
      this.chatFile = {}
      this.rosterFile = {}
    },
    handleFileUpload () {
      this.rosterFile = this.$refs.file.files[0]
    },
    handleChatFileUpload () {
      this.chatFile = this.$refs.chatfile.files[0]
    }
  }
}
</script>

<style lang="scss" scoped>
#paragraphTag
{
    color:"red"
}
#changeColor{
  color:"red"
}
.headerText{
  padding-left:21px;
  color:grey
}
.uploadTextTag{
  padding:21px;
  display:flex;
  justify-content:center;
}
.inputText{
  border:1px solid
}
.fieldsDiv{
  display:flex;
  flex-direction:row;
  justify-content:center;
}
.buttons{
  display:flex;
  flex-direction:row;
  justify-content:center;
  padding-top:20px;
}
.message{
  display:flex;
  flex-direction:column;
}
.msg{
  display:flex;
  font-size:12px;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/UploadDoctorRoster.vue